import { combineReducers } from 'redux'
import common from './common/reducer'
import provinces from './province/reducer'
import authUser from './auth/reducer'
import registeremails from './registeremail/reducer'
import forgots from './forgot/reducer'
import settings from './settings/reducer'
import members from './member/reducer'
import programs from './program/reducer'

const reducers = combineReducers({
  authUser,
  registeremails,
  forgots,
  common,
  provinces,
  settings,
  members,
  programs
})

const initialState = reducers({}, {})

const rootReducer = (state, action) => {
  if (action.type === 'LOGOUT_USER') {
    state = initialState
  }

  return reducers(state, action)
}

export default rootReducer
